import { Title, Text, ThemeIcon, Stack, Paper, Flex, Anchor } from "@mantine/core";
import { IconHeadphones, IconCircleCheck, IconTool, IconUsers, IconFileText, IconBuilding } from "@tabler/icons-react";

export default function HelpCategoriesSection() {
  return (
    <Flex direction="column" align="center" py={60} px="xl" maw={1200} mx="auto" w="100%">
      <Stack align="center" gap="xl" mb={60}>
        <Title order={2} ta="center" fw={400}>
          How Can We Help?
        </Title>
        <Text c="slate.6" size="lg" ta="center" maw={600} fw={400}>
          Choose the category that best matches your inquiry
        </Text>
      </Stack>

      <Flex gap="xl" wrap="wrap" w="100%">
        {/* Sales & Demos */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Stack gap="md">
            <ThemeIcon size={48} radius="xl" color="primary" variant="light">
              <IconHeadphones size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb="xs">
                Sales & Demos
              </Text>
              <Text size="sm" c="slate.6" mb="md" lh={1.5}>
                Interested in GT Setu? Schedule a product demo or discuss pricing options.
              </Text>
              <Anchor href="mailto:sales@gtconnect.com" size="sm" c="primary.6">
                sales@gtconnect.com
              </Anchor>
            </div>
          </Stack>
        </Paper>

        {/* Verification Support */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Stack gap="md">
            <ThemeIcon size={48} radius="xl" color="teal" variant="light">
              <IconCircleCheck size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb="xs">
                Verification Support
              </Text>
              <Text size="sm" c="slate.6" mb="md" lh={1.5}>
                Need help with compliance verification or approval status? We're here to assist.
              </Text>
              <Anchor href="mailto:verify@gtconnect.com" size="sm" c="primary.6">
                verify@gtconnect.com
              </Anchor>
            </div>
          </Stack>
        </Paper>

        {/* Technical Support */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Stack gap="md">
            <ThemeIcon size={48} radius="xl" color="orange" variant="light">
              <IconTool size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb="xs">
                Technical Support
              </Text>
              <Text size="sm" c="slate.6" mb="md" lh={1.5}>
                Having technical issues? Our support team is ready to help you resolve them.
              </Text>
              <Anchor href="mailto:support@gtconnect.com" size="sm" c="primary.6">
                support@gtconnect.com
              </Anchor>
            </div>
          </Stack>
        </Paper>

        {/* Partnerships */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Stack gap="md">
            <ThemeIcon size={48} radius="xl" color="violet" variant="light">
              <IconUsers size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb="xs">
                Partnerships
              </Text>
              <Text size="sm" c="slate.6" mb="md" lh={1.5}>
                Explore partnership opportunities and collaboration with GT Setu.
              </Text>
              <Anchor href="mailto:partners@gtconnect.com" size="sm" c="primary.6">
                partners@gtconnect.com
              </Anchor>
            </div>
          </Stack>
        </Paper>

        {/* Billing & Pricing */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Stack gap="md">
            <ThemeIcon size={48} radius="xl" color="red" variant="light">
              <IconFileText size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb="xs">
                Billing & Pricing
              </Text>
              <Text size="sm" c="slate.6" mb="md" lh={1.5}>
                Questions about invoices, subscriptions, or pricing plans? Contact our billing team.
              </Text>
              <Anchor href="mailto:billing@gtconnect.com" size="sm" c="primary.6">
                billing@gtconnect.com
              </Anchor>
            </div>
          </Stack>
        </Paper>

        {/* Enterprise Solutions */}
        <Paper p="xl" radius="lg" bg="white" withBorder flex={1} miw={300}>
          <Stack gap="md">
            <ThemeIcon size={48} radius="xl" color="indigo" variant="light">
              <IconBuilding size={24} />
            </ThemeIcon>
            <div>
              <Text fw={600} size="lg" mb="xs">
                Enterprise Solutions
              </Text>
              <Text size="sm" c="slate.6" mb="md" lh={1.5}>
                Looking for custom enterprise solutions or large-scale implementations?
              </Text>
              <Anchor href="mailto:enterprise@gtconnect.com" size="sm" c="primary.6">
                enterprise@gtconnect.com
              </Anchor>
            </div>
          </Stack>
        </Paper>
      </Flex>
    </Flex>
  );
}
